import { ampli } from '@/ampli';

import { buttons } from '@/styles/buttons';
import { fontStyles } from '@/styles/typography';

import { DiscoveryTimeframe } from '@/utils/discovery/types';

import { timeframeList } from '../filtersDefinitions';

type TimeframeOption = { label: string; value: DiscoveryTimeframe };

export type TimeframeFilterProps = {
  timeframe: DiscoveryTimeframe;
  category?: string;
  onTimeframeChange: (timeframe: DiscoveryTimeframe) => void;
  options?: readonly TimeframeOption[];
};

export const TimeframeFilter = ({
  timeframe,
  category = 'trending',
  onTimeframeChange,
  options = timeframeList,
}: TimeframeFilterProps) => {
  const handleTimeframeClick = (timeframe: TimeframeOption) => {
    ampli.categoryFilterSelected({
      filter_value: timeframe.value,
    });
    ampli.homepageTimeframeChanged({
      category,
      timeframe_label: timeframe.label,
    });
    onTimeframeChange(timeframe.value);
  };

  return (
    <div className="flex items-center gap-1 border border-token-gray-400 rounded-sm p-1">
      {options.map((item) => (
        <button
          key={item.value}
          className={buttons({
            size: 'extraSmall',
            shape: 'roundedSubtle',
            color: timeframe === item.value ? 'gray' : 'transparent',
            class: 'px-2',
          })}
          onClick={() => handleTimeframeClick(item)}
        >
          <p
            className={fontStyles({
              variant: 'LABEL_MD',
              class: timeframe !== item.value ? 'text-token-gray-900' : undefined,
            })}
          >
            {item.label}
          </p>
        </button>
      ))}
    </div>
  );
};
